module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M22 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h20c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM10 2h4v2h-4V2zm4 27a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zm6-5H4V6h16v18zM7 14h10a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1zm0 6h10a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/smart-phone-1.js
// module id = 1424
// module chunks = 14